import { render, staticRenderFns } from "./TcmBrainSetting.vue?vue&type=template&id=8b60b3e2&scoped=true&"
import script from "./TcmBrainSetting.vue?vue&type=script&lang=ts&"
export * from "./TcmBrainSetting.vue?vue&type=script&lang=ts&"
import style0 from "./TcmBrainSetting.vue?vue&type=style&index=0&id=8b60b3e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b60b3e2",
  null
  
)

export default component.exports